import toast from "react-hot-toast";

import { nextCargoApi } from "../../baseApi";
import { GetCompanies, GetCompanyByHost } from "./company.types";

export const companyApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Get all companies
     * @returns Array of companies with basic information
     */
    getCompanies: build.query<GetCompanies["result"], GetCompanies["args"]>({
      query: () => "/company",
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando empresas...",
          success: "Empresas carregadas com sucesso!",
          error: "Erro ao carregar empresas."
        });
      }
    }),

    /**
     * Get a single company by Host
     * @param host - Company host
     * @returns Full company details
     */
    getCompanyByHost: build.query<GetCompanyByHost["raw"], GetCompanyByHost["args"], GetCompanyByHost["result"]>({
      query: (params) => ({
        url: "/company/host/",
        params
      }),
      transformResponse: (response) => {
        const { whatsapp, ...data } = response;
        const text = whatsapp ? "Olá! Preciso de ajuda.\nEstou com dificuldades para acessar o sistema ou seguir com minha entrada na fila." : "";
        const raw: GetCompanyByHost["raw"] = {
          ...data,
          whatsapp: whatsapp ? { phone: whatsapp, link: `https://wa.me/${whatsapp}?text=${encodeURIComponent(text)}` } : null
        };

        return raw;
      }
    })
  })
});

companyApi.enhanceEndpoints({
  addTagTypes: ["CompanyByHost", "Companies"],
  endpoints: {
    getCompanyByHost: {
      providesTags: (result, err, { host }) => [{ type: "CompanyByHost", id: result?.id ?? host }]
    },
    getCompanies: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "Companies" as const, id })), { type: "Companies", id: "LIST" }] : [{ type: "Companies", id: "LIST" }]
    }
  }
});
